export type HarmRank = 'critical' | 'major' | 'moderate' | 'minor';

export type HarmDomain =
  | 'Ethics'
  | 'Safety'
  | 'Legal'
  | 'Security'
  | 'Performance'
  | 'Sustainability';

export type StakeholderHarmRow = {
  id: string;
  rank: HarmRank;
  stakeholderGroup: string;
  hazardDescriptions: string[];
  harmDescription: string;
  domains: HarmDomain[];
  detailAndReasoning: string;
  furtherDetailAndReasoningBullets: string[];
  lifecycle: string;
  accountableParties: string;
};

export const RISK_CONCENTRATION_TITLE = 'Impact concentration by stakeholder type';

export function countHarmsByRank(rows: StakeholderHarmRow[]) {
  const counts: Record<HarmRank, number> = {
    critical: 0,
    major: 0,
    moderate: 0,
    minor: 0,
  };
  for (const r of rows) {
    counts[r.rank] += 1;
  }
  return counts;
}
